// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__3NwQ-","paramInput":"JobSimulator_paramInput__37pTx","input":"JobSimulator_input__35cpt"};